import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiError } from "@/lib/api";
import SEO from "@/components/SEO";

const PORTAL_BG = "https://static.prod-images.emergentagent.com/jobs/a1668682-6cd0-4608-a6a8-d20136862eb0/images/4c35ee50ad48f91ef2b819294383a0cc48576fa6157c7103d4e3da46fd01d36b.png";

export default function DealerLogin() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(form.email, form.password);
      toast.success("Hoş geldiniz!");
      if (user.role === "admin") nav("/admin");
      else nav("/bayi-panel");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <SEO title="Bayi Girişi" description="Wünberg Bayi Portalı — onaylı bayilerimizin sipariş, fiyat listesi ve materyallere erişim noktası." />
      <section className="relative min-h-[calc(100vh-80px)] flex items-center">
        <div className="absolute inset-0">
          <img src={PORTAL_BG} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-[#030f26]/85" />
        </div>
        <div className="relative z-10 wb-container py-20">
          <div className="max-w-md mx-auto wb-glass p-10">
            <div className="wb-overline">Bayi Portalı</div>
            <h1 className="wb-h2 mt-3">Bayi Girişi</h1>
            <p className="text-sm text-[#a0aabf] mt-3">
              Onaylı bayilerimiz için özel portal. Henüz bayi değilseniz{" "}
              <Link to="/bayi-basvuru" className="text-[#d4af37] hover:underline">başvuru yapın</Link>.
            </p>

            <form onSubmit={submit} className="mt-8 space-y-4" data-testid="dealer-login-form">
              <input
                className="wb-input"
                type="email"
                placeholder="E-posta adresiniz"
                required
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                data-testid="dealer-login-email"
              />
              <input
                className="wb-input"
                type="password"
                placeholder="Şifre"
                required
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                data-testid="dealer-login-password"
              />
              <button type="submit" disabled={loading} className="wb-btn-primary w-full" data-testid="dealer-login-submit">
                {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
              </button>
            </form>

            <div className="mt-6 text-xs text-[#a0aabf] text-center">
              Yetkilendirme sorunları için <Link to="/iletisim" className="text-[#d4af37]">iletişime geçin</Link>.
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
